module.exports = __webpack_public_path__ + "img/o2o-banner.16c29363.png";